(() => {
  const players = new Map();

  const stopPlayer = (button) => {
    const audio = players.get(button);
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', button.dataset.playLabel || 'Fragment beluisteren');
  };

  const initAudioButton = (button) => {
    if (button.dataset.sprReady === 'true') return;
    button.dataset.sprReady = 'true';
    button.setAttribute('aria-pressed', 'false');

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const source = button.dataset.audioSrc;
      if (!source) return;

      document.querySelectorAll('.spr-audio-button[aria-pressed="true"]').forEach((other) => {
        if (other !== button) stopPlayer(other);
      });

      let audio = players.get(button);
      if (!audio) {
        audio = new Audio(source);
        players.set(button, audio);
        audio.addEventListener('ended', () => stopPlayer(button));
        audio.addEventListener('error', () => stopPlayer(button));
      }

      if (audio.paused) {
        audio.play().then(() => {
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', button.dataset.pauseLabel || 'Fragment pauzeren');
        }).catch(() => stopPlayer(button));
      } else {
        audio.pause();
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', button.dataset.playLabel || 'Fragment beluisteren');
      }
    });
  };

  const initCarousel = (carousel) => {
    if (carousel.dataset.sprReady === 'true') return;
    carousel.dataset.sprReady = 'true';

    const track = carousel.querySelector('[data-spr-carousel-track]');
    const previous = carousel.querySelector('[data-spr-carousel-prev]');
    const next = carousel.querySelector('[data-spr-carousel-next]');
    if (!track) return;

    const scrollAmount = () => {
      const card = track.querySelector('.spr-product-card') || track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };

    const updateButtons = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    };

    previous?.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  };

  const equalizeLetterGameCopy = (grid) => {
    const copies = Array.from(grid.querySelectorAll('.spr-letter-games-card__copy'));
    copies.forEach((copy) => {
      copy.style.minHeight = window.innerWidth >= 900 ? '0px' : '';
    });

    if (window.innerWidth < 900 || copies.length < 2) return;

    const tallestCopy = Math.ceil(Math.max(...copies.map((copy) => copy.scrollHeight)));
    copies.forEach((copy) => {
      copy.style.minHeight = `${tallestCopy}px`;
    });
  };

  const initLetterGameGrid = (grid) => {
    if (grid.dataset.sprAlignmentReady === 'true') return;
    grid.dataset.sprAlignmentReady = 'true';

    let animationFrame;
    const align = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(() => equalizeLetterGameCopy(grid));
    };

    window.addEventListener('resize', align, { passive: true });
    document.fonts?.ready.then(align);
    align();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('.spr-audio-button').forEach(initAudioButton);
    scope.querySelectorAll('[data-spr-carousel]').forEach(initCarousel);
    scope.querySelectorAll('.spr-letter-games__grid').forEach(initLetterGameGrid);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
